import { SavingsKpisActionTypes } from './constants';

export const INIT_STATE = {
    loadingShipmentsBaselineCost: false,
    errorGetShipmentsBaselineCost: null,
    shipmentsBaselineCost: null,

    loadingShipmentsBaselineRatedCost: false,
    errorGetShipmentsBaselineRatedCost: null,
    shipmentsBaselineRatedCost: null,
    
    loadingShipmentsBaselineCostCount: false,
    errorGetShipmentsBaselineCostCount: null,
    shipmentsBaselineCostCount: null,
    
    loadingShipmentsCostByCarrier: false,
    errorGetShipmentsCostByCarrier: null,
    shipmentsCostByCarrier: null,
    
    loadingShipmentsCostByTimeframe: false,
    errorGetShipmentsCostByTimeframe: null,
    shipmentsCostByTimeframe: null,
    
    loadingShipmentsCostOverview: false,
    errorGetShipmentsCostOverview: null,
    shipmentsCostOverview: null,
};

type SavingsKpisAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};

type State = {
    loadingShipmentsBaselineCost: false,
    errorGetShipmentsBaselineCost: null,
    shipmentsBaselineCost: null,
    loadingShipmentsBaselineRatedCost: false,
    errorGetShipmentsBaselineRatedCost: null,
    shipmentsBaselineRatedCost: null,
    loadingShipmentsBaselineCostCount: false,
    errorGetShipmentsBaselineCostCount: null,
    shipmentsBaselineCostCount: null,
    loadingShipmentsCostByCarrier: false,
    errorGetShipmentsCostByCarrier: null,
    shipmentsCostByCarrier: null,
    loadingShipmentsCostByTimeframe: false,
    errorGetShipmentsCostByTimeframe: null,
    shipmentsCostByTimeframe: null,
    loadingShipmentsCostOverview: false,
    errorGetShipmentsCostOverview: null,
    shipmentsCostOverview: null,
};

const SavingsKpis = (state: State = INIT_STATE, action: SavingsKpisAction): any => {
    switch (action.type) {
        case SavingsKpisActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case SavingsKpisActionTypes.GET_SHIPMENTS_BASELINE_COST_REQUEST: {
                    return { ...state, loadingShipmentsBaselineCost: false, shipmentsBaselineCost: action.payload.data };
                }
                case SavingsKpisActionTypes.GET_SHIPMENTS_BASELINE_RATED_COST_REQUEST: {
                    return { ...state, loadingShipmentsBaselineRatedCost: false, shipmentsBaselineRatedCost: action.payload.data };
                }
                case SavingsKpisActionTypes.GET_SHIPMENTS_BASELINE_COST_COUNT_REQUEST: {
                    return { ...state, loadingShipmentsBaselineCostCount: false, shipmentsBaselineCostCount: action.payload.data };
                }
                case SavingsKpisActionTypes.GET_SHIPMENTS_COST_BY_CARRIER_REQUEST: {
                    return { ...state, loadingShipmentsCostByCarrier: false, shipmentsCostByCarrier: action.payload.data };
                }
                case SavingsKpisActionTypes.GET_SHIPMENTS_COST_BY_TIMEFRAME_REQUEST: {
                    return { ...state, loadingShipmentsCostByTimeframe: false, shipmentsCostByTimeframe: action.payload.data };
                }
                case SavingsKpisActionTypes.GET_SHIPMENTS_COST_OVERVIEW_REQUEST: {
                    return { ...state, loadingShipmentsCostOverview: false, shipmentsCostOverview: action.payload.data };
                }
                default:
                    return { ...state, loadingShipmentsBaselineCost: false, loadingShipmentsBaselineRatedCost: false, loadingShipmentsBaselineCostCount: false, loadingShipmentsCostByCarrier: false, loadingShipmentsCostByTimeframe: false, loadingShipmentsCostOverview: false };
            }

        case SavingsKpisActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case SavingsKpisActionTypes.GET_SHIPMENTS_BASELINE_COST_REQUEST: {
                    return { ...state, loadingShipmentsBaselineCost: false, errorGetShipmentsBaselineCost: action.payload.error };
                }
                case SavingsKpisActionTypes.GET_SHIPMENTS_BASELINE_RATED_COST_REQUEST: {
                    return { ...state, loadingShipmentsBaselineRatedCost: false, errorGetShipmentsBaselineRatedCost: action.payload.error };
                }
                case SavingsKpisActionTypes.GET_SHIPMENTS_BASELINE_COST_COUNT_REQUEST: {
                    return { ...state, loadingShipmentsBaselineCostCount: false, errorGetShipmentsBaselineCostCount: action.payload.error };
                }
                case SavingsKpisActionTypes.GET_SHIPMENTS_COST_BY_CARRIER_REQUEST: {
                    return { ...state, loadingShipmentsCostByCarrier: false, errorGetShipmentsCostByCarrier: action.payload.error };
                }
                case SavingsKpisActionTypes.GET_SHIPMENTS_COST_BY_TIMEFRAME_REQUEST: {
                    return { ...state, loadingShipmentsCostByTimeframe: false, errorGetShipmentsCostByTimeframe: action.payload.error };
                }
                case SavingsKpisActionTypes.GET_SHIPMENTS_COST_OVERVIEW_REQUEST: {
                    return { ...state, loadingShipmentsCostOverview: false, errorGetShipmentsCostOverview: action.payload.error };
                }
                default:
                    return { ...state };
            }

        case SavingsKpisActionTypes.GET_SHIPMENTS_BASELINE_COST_REQUEST:
            return { ...state, loadingShipmentsBaselineCost: true, shipmentsBaselineCost: null };
        case SavingsKpisActionTypes.GET_SHIPMENTS_BASELINE_RATED_COST_REQUEST:
            return { ...state, loadingShipmentsBaselineRatedCost: true, shipmentsBaselineRatedCost: null };
        case SavingsKpisActionTypes.GET_SHIPMENTS_BASELINE_COST_COUNT_REQUEST:
            return { ...state, loadingShipmentsBaselineCostCount: true, shipmentsBaselineCostCount: null };
        case SavingsKpisActionTypes.GET_SHIPMENTS_COST_BY_CARRIER_REQUEST:
            return { ...state, loadingShipmentsCostByCarrier: true, shipmentsCostByCarrier: null };
        case SavingsKpisActionTypes.GET_SHIPMENTS_COST_BY_TIMEFRAME_REQUEST:
            return { ...state, loadingShipmentsCostByTimeframe: true, shipmentsCostByTimeframe: null };
        case SavingsKpisActionTypes.GET_SHIPMENTS_COST_OVERVIEW_REQUEST:
            return { ...state, loadingShipmentsCostOverview: true, shipmentsCostOverview: null };
        default:
            return { ...state };
    }
};

export default SavingsKpis;
